import DisabledOrPrivateInfo from './DisabledOrPrivateInfo';
import DisabledOrPrivateInfoContainer from './DisabledOrPrivateInfo.container';

export default DisabledOrPrivateInfoContainer(DisabledOrPrivateInfo);
